import React, { useState } from "react"
import { StaticImage } from "gatsby-plugin-image"
import "../styles/pages/landing-page.less"
import { Link } from "gatsby"
import { toCapitalize } from "../utils/helpers"
import { useSiteLocation } from "../hooks"

const LocationSelect = ({ location }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const siteLocation = useSiteLocation(location.pathname)

  /* eslint-disable */
  return (
    <div className="py-4 inline-block pr-0">
      <div
        className={`${
          isExpanded ? "block" : "hidden"
        } h-screen w-full fixed top-0 left-0 z-20`}
        onClick={() => setIsExpanded(!isExpanded)}
      ></div>
      <div
        className="group relative outline-none"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <button className="p-1 w-32 border-[#CCC5C2] border-solid border">
          <StaticImage src="../static/images/icon/location.svg" alt="logo" />
          <span className="mx-3 font-semibold text-[#505050] capitalize">
            {toCapitalize(siteLocation)}
          </span>
          <StaticImage
            src="../static/images/icon/angle-arrow-down.svg"
            alt="logo"
          />
        </button>
        <nav
          className={`border-[#CCC5C2] border-solid border bg-primary border-gray-800 rounded w-32 absolute left-0 top-full transition-all  ${
            isExpanded
              ? "visible opacity-100 translate-y-1 z-20"
              : "invisible opacity-0"
          }`}
        >
          <ul className="py-1">
            <Link
              to={`/au/sydney${
                location.pathname.includes("/blog") ? "/blog" : "/"
              }`}
            >
              <li className="block px-4 py-2 hover:bg-secondary cursor-pointer text-[#505050] font-medium">
                Sydney
              </li>
            </Link>
            <Link
              to={`/us/boston${
                location.pathname.includes("/blog") ? "/blog" : "/"
              }`}
            >
              <li className="block px-4 py-2 hover:bg-secondary cursor-pointer text-[#505050] font-medium">
                Boston
              </li>
            </Link>
            <Link
              to={`/ca/toronto${
                location.pathname.includes("/blog") ? "/blog" : "/"
              }`}
            >
              <li className="block px-4 py-2 hover:bg-secondary cursor-pointer text-[#505050] font-medium">
                Toronto
              </li>
            </Link>
          </ul>
        </nav>
      </div>
    </div>
  )
}

export default LocationSelect
